import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e('<path fill="#FFDA44" d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20l-20 1.74L0 20Z"></path><path fill="#D80027" d="M2.676 30C6.134 35.978 12.597 40 20 40c7.403 0 13.865-4.022 17.324-10L20 28.695 2.676 30Z"></path><path fill="#0052B4" d="M37.324 30A19.908 19.908 0 0 0 40 20H0c0 3.643.975 7.058 2.676 10h34.648Z"></path><path fill="#FFDA44" d="M20 26.956a6.956 6.956 0 1 0 0-13.912 6.956 6.956 0 0 0 0 13.912Z"></path><path fill="#338AF3" d="M20 24.348A4.353 4.353 0 0 1 15.652 20v-2.609A4.353 4.353 0 0 1 20 13.044a4.353 4.353 0 0 1 4.348 4.347V20A4.353 4.353 0 0 1 20 24.348Z"></path><path fill="#000" d="M26.956 9.565H21.74a1.74 1.74 0 0 0-3.478 0h-5.218c0 .96.837 1.74 1.797 1.74h-.058c0 .96.779 1.739 1.74 1.739 0 .96.778 1.739 1.739 1.739h3.478c.96 0 1.74-.779 1.74-1.74.96 0 1.738-.778 1.738-1.739h-.058c.96 0 1.797-.778 1.797-1.739Z"></path>', 6), l = [
  c
];
function o(p, d) {
  return t(), a("svg", h, [...l]);
}
const n = { render: o };
export {
  n as default,
  o as render
};
